export default __webpack_public_path__ + "static/media/notfound.fda2e1fc.png";